import { Component, Input, OnInit } from '@angular/core';
import { Exercise } from 'src/models/exercise.model';

@Component({
    selector: 'app-exercise-thumbnail',
    templateUrl: './exercise-thumbnail.component.html',
    styleUrls: ['./exercise-thumbnail.component.scss'],
    standalone: false
})
export class ExerciseThumbnailComponent implements OnInit {
  isDark = document.body.classList.contains('dark');
  @Input() exercise!: Exercise;

  constructor() {}

  ngOnInit() {}
}
